import styled from 'styled-components';

const StyledBannerShelfzone = styled.div`
  background-color: #000000;
  padding-right: 0;
  padding-left: 64px;
  .banner--content{
    width: 100%;
    display: flex;
    align-items: center;
  }
  .banner--col{
    position: relative;
    flex: 1 0 50%;
    padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
    overflow: hidden;
    align-self: stretch;
    background-size: cover;
  }
  .banner--col-text{
    padding-right: 64px;
  }
  .banner--col img {
    position: absolute;
    width: 100%;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
  }
  .banner-subtitle{
    padding-bottom: 24px;
  }
  h5{
    padding-bottom: 40px;
    color: #fff;
  }
  a{
    display: flex;
    align-items: center;
  }
  a svg{
    margin-left: 16px; 
  }
  @media screen and (max-width: 1439px){
    padding-left: 40px;
    .banner--col-text{
      padding-right: 40px;
    }
  }
  @media screen and (max-width: 1023px){
 
    h5{
      padding-bottom: 32px;
    }
    .banner--col{
      padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
      padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    }
  }
  @media screen and (max-width: 767px){
    padding-left: 0;
    .banner-subtitle{
      padding-bottom: 16px;
    }
    h5{
      padding-bottom: 24px;
    }
    .banner--content{
      flex-direction: column-reverse;
    }
    .banner--col-text{
      padding-right: 24px;
      padding-left: 24px;
    }
    .banner--col{
      padding-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;
      padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    }
    .banner--col-image{
      width: 100%;
      padding: 0;
    }
    .banner--col-image:after {
      content: "";
      display: block;
      padding-bottom: 100%;
  }
`;

export {
  StyledBannerShelfzone,
};

